import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Col, Row } from 'antd'
import SocketProvider from '../SocketProvider'
import LiveDashboard from './LiveDashboard'

const Live = (props) => {
  const { id } = useParams()

  const [tournamentId, setTournamentId] = useState()

  useEffect(() => {
    if (id) {
      console.log('params')
      setTournamentId(id)
    } else if (props.id) {
      console.log('props')
      setTournamentId(props.id)
    }
  }, [props.id, id])

  return (
    <SocketProvider>
      <LiveDashboard id={tournamentId} />
    </SocketProvider>
  )
}

export default withAuthenticationRequired(Live, {
  onRedirecting: () => (
    <Row>
      <Col span={24} style={{ textAlign: 'center' }}>Loading</Col>
    </Row>
  )
})
